import loadable from '@loadable/component';

// 懒加载组件
const DeliveryQuery = loadable(() => import('./deliveryQuery/DeliveryQuery'));
const DeliveryModify = loadable(() => import('./deliveryQuery/deliveryModify/DeliveryModify'));
const DeliveryJd903Modify = loadable(() => import('./deliveryQuery/deliveryJd903Modify/DeliveryJd903Modify'));
const OrderQuery = loadable(() => import('./orderQuery/OrderQuery'));
const DeliveryDetailQuery = loadable(() => import('./deliveryDetailQuery/DeliveryDetailQuery'));
const DeliveryReturnQuery = loadable(() => import('./deliveryReturnQuery/DeliveryReturnQuery'));

export default [
  {
    path: '/DeliveryQuery',
    component: DeliveryQuery
  },
  {
    path: '/DeliveryModify',
    component: DeliveryModify
  },
  {
    path: '/DeliveryJd903Modify',
    component: DeliveryJd903Modify
  },
  {
    path: '/OrderQuery',
    component: OrderQuery
  },
  {
    path: '/DeliveryDetailQuery',
    component: DeliveryDetailQuery
  },
  {
    path: '/DeliveryReturnQuery',
    component: DeliveryReturnQuery
  }
];
